import { useSelector } from 'react-redux';
import { IUserMenuItemProps, UserMenuItemComponent } from '../user-menu-item/userMenuItemComponent';
import './userMenuComponent.scss';
import { FC, useCallback, useState } from 'react';
import { AuthActions } from '../../../redux/AuthActions';
import { UserMenuState } from './model';
import { useNavigate } from 'react-router';
import { RootState } from '../../../redux/AppReducer';
import { AppActions } from '../../../redux/AppActions';
import { PROFILE_ROUTES } from '../../../common/constants';
import { handleTracking } from '../../../helpers/handelTracking';
import { v4 as uuidv4 } from 'uuid';
import { TrackingEventStatus, TrackingEventType, ITrackingEvent } from '../../../common/view-model';
import { useAppDispatch } from '../../../redux/store';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { buildTrackingBobPayload } from '../../../helpers/handleBobTracking';
import { findUserAccessType } from '../../../helpers/findUserAccessType';
import { UserType } from '../../../common/model';
interface IUserMenuComponent {
	onClose: () => void;
	mobileView?: boolean;
	eventLink?: string;
}

export const UserMenuComponent: FC<IUserMenuComponent> = ({ onClose, mobileView, eventLink }) => {
	const expoMapOption = 'Show Expo Floor Plan';
	const dispatch = useAppDispatch();
	const logout = useCallback(() => dispatch(AuthActions.logout()), [dispatch]);
	const [state] = useState({ ...UserMenuState });
	const navigate = useNavigate();
	const userState = useSelector((state: RootState) => state.appState.userState?.user);
	const [_hasNotification, setHasNotification] = useLocalStorage('hub-notification', true);
	const currentEvent = useSelector(
		(state: RootState) => state.appState.storeState?.getCurrentEvent
	);

	const goToPage = (path: string) => {
		dispatch(AppActions.setGeneralError({ hasError: false }));
		if (userState?.isBrandAdmin) {
			setHasNotification(false);
		}
		if (path === PROFILE_ROUTES.BRAND_INFO) {
			const trackingPayload = buildTrackingBobPayload({
				type: TrackingEventType.BOB_TRACKING_BEACON_HUB,
				user: {
					id: userState?.id || '',
					type: userState.user_type || ''
				},
				event: {
					id: 'bob-tracking-menu',
					name: 'bob-tracking-menu',
					type: 'bob-tracking'
				}
			});
			handleTracking(trackingPayload);
		}
		navigate(path);
	};

	const handleFavoriteTrackEvent = () => {
		const trackingPayload: ITrackingEvent = {
			transactionId: uuidv4(),
			entityId: userState.id?.toString()!,
			status: TrackingEventStatus.SUCCESS,
			type: TrackingEventType.CLICK_ON_FAVORITES_IN_PROFILE,
			timeStamp: new Date().toISOString(),
			eventPayload: {
				id: userState.id?.toString()!,
				name: 'click-fav-nav',
				type: TrackingEventType.CLICK_ON_FAVORITES_IN_PROFILE,
				url: window.location.href,
				tags: [],
				metadata: {
					user_type: userState?.user?.user_type,
					user_id: userState?.user?.id,
					environment: import.meta.env.VITE_ENV_NAME
				}
			}
		};
		handleTracking(trackingPayload);
	};

	const handleExpoClick = () => {
		handleTracking({
			transactionId: uuidv4(),
			status: TrackingEventStatus.SUCCESS,
			entityId: currentEvent?.id!,
			type: TrackingEventType.CLICK_ON_EXPO_MAP,
			timeStamp: new Date().toISOString(),
			eventPayload: {
				id: currentEvent?.id!,
				name: currentEvent?.name!,
				type: currentEvent?.name!,
				url: window.location.href,
				tags: [],
				metadata: {
					user_id: userState?.id,
					user_type: userState?.user_type,
					environment: import.meta.env.VITE_ENV_NAME,
					event_id: currentEvent?.id,
					event_name: currentEvent?.name
				}
			}
		});
	};
	const [menuItems] = useState<IUserMenuItemProps[]>(
		!mobileView
			? [
					{
						name: `${userState?.first_name} ${userState?.last_name} `,
						subTitle: 'View Your Profile',
						icon: 'ri-account-circle-line',
						onClick: () => {
							goToPage(PROFILE_ROUTES.PROFILE);
						}
					},
					{
						name: 'Get your products on to Beacon Discovery!',
						onClick: () => {
							goToPage(PROFILE_ROUTES.GET_ON_BEACON);
						}
					},
					{
						name: 'Your Favorites',
						icon: 'ri-heart-line',
						onClick: () => {
							handleFavoriteTrackEvent();
							goToPage(PROFILE_ROUTES.FAVORITES);
						}
					},
					{
						name: 'My Beacon Hub',
						onClick: () => {
							goToPage(PROFILE_ROUTES.BRAND_INFO);
						}
					},
					{
						name: 'Ingredient Templates',
						icon: 'ri-file-list-2-line',
						onClick: () => {
							goToPage(PROFILE_ROUTES.INGREDIENTS);
						}
					},
					{
						name: 'Log Out',
						icon: 'ri-logout-box-line',
						onClick: () => {
							document?.getElementById(state.iirisLogoutButtonId)?.click();
							logout();
						}
					}
			  ]
			: [
					{
						name: `${userState?.first_name} ${userState?.last_name} `,
						subTitle: 'View Your Profile',
						icon: 'ri-account-circle-line',
						onClick: () => {
							goToPage(PROFILE_ROUTES.PROFILE);
						}
					},
					{
						name: 'Get your products on to Beacon Discovery!',
						onClick: () => {
							goToPage(PROFILE_ROUTES.GET_ON_BEACON);
						}
					},
					{
						name: 'Your Favorites',
						icon: 'ri-heart-line',
						onClick: () => {
							handleFavoriteTrackEvent();
							goToPage(PROFILE_ROUTES.FAVORITES);
						}
					},
					{
						name: 'Ingredient Templates',
						icon: 'ri-file-list-2-line',
						onClick: () => {
							goToPage(PROFILE_ROUTES.INGREDIENTS);
						}
					},
					{
						name: 'My Beacon Hub',
						onClick: () => {
							goToPage(PROFILE_ROUTES.BRAND_INFO);
						}
					},
					{
						name: 'Show Expo Floor Plan',
						icon: 'ri-map-2-line',
						onClick: () => {
							if (eventLink) {
								window.open(eventLink, '_blank', 'noopener noreferrer');
								handleExpoClick();
							}
						}
					},
					// {
					// 	name: 'Newtopia Map',
					// 	icon: 'ri-map-2-line',
					// 	onClick: () => {
					// 		if (eventLink) {
					// 			window.open(eventLink, '_blank', 'noopener noreferrer');
					// 			handleExpoClick();
					// 		}
					// 	}
					// },
					{
						name: 'Log Out',
						icon: 'ri-logout-box-line',
						onClick: () => {
							document?.getElementById(state.iirisLogoutButtonId)?.click();
							logout();
						}
					}
			  ]
	);
	const userFullAccess = findUserAccessType(userState?.user_type) !== UserType.Brand;
	const filteredMenuItems = menuItems
		.filter(item => {
			if (!userFullAccess && item.name === 'Ingredient Templates') {
				return false;
			}
			return true;
		})
		.filter(menuItem => {
			if (!userState?.isBrandAdmin && menuItem.name === 'My Beacon Hub') {
				return false;
			}
			return true;
		});
	return (
		<div className='user-menu' id='user-menu'>
			{filteredMenuItems
				.filter(item => (!eventLink ? item.name !== expoMapOption : item))
				.map((item: IUserMenuItemProps, index: number) => (
					<UserMenuItemComponent
						data-testid='user-menu-item'
						key={index}
						name={item.name}
						onClick={() => {
							item.onClick();
							onClose();
						}}
						icon={item?.icon}
						subTitle={item?.subTitle}
					/>
				))}
		</div>
	);
};
